
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  CardDescription,
} from "@/components/ui/card";
import { formatDateTime, getStatusColor } from "@/utils/admin-utils";

interface RecentBookingsTabProps {
  bookings: any[];
}

export const RecentBookingsTab = ({ bookings }: RecentBookingsTabProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Recent Bookings</CardTitle>
        <CardDescription>Overview of all bookings in the system</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {bookings.map((booking) => (
            <Card key={booking.id} className="p-4">
              <div className="flex justify-between items-start">
                <div className="flex-grow">
                  <div className="flex justify-between items-center">
                    <h3 className="font-semibold text-lg">
                      {booking.profiles?.first_name} {booking.profiles?.last_name}
                    </h3>
                    <span className={`px-3 py-1 rounded-full text-xs ${getStatusColor(booking.status)}`}>
                      {booking.status.charAt(0).toUpperCase() + booking.status.slice(1)}
                    </span>
                  </div>
                  <div className="grid grid-cols-2 gap-4 mt-4">
                    <div className="space-y-2">
                      <p className="text-sm">
                        <span className="font-medium">Location:</span><br/>
                        {booking.parking_spot?.address}
                      </p>
                      <p className="text-sm">
                        <span className="font-medium">Spot Owner:</span><br/>
                        {booking.parking_spot?.owner_name}
                      </p>
                      <p className="text-sm">
                        <span className="font-medium">Booking ID:</span><br/>
                        {booking.id}
                      </p>
                    </div>
                    <div className="space-y-2">
                      <p className="text-sm">
                        <span className="font-medium">Start Time:</span><br/>
                        {formatDateTime(booking.start_time)}
                      </p>
                      <p className="text-sm">
                        <span className="font-medium">End Time:</span><br/>
                        {formatDateTime(booking.end_time)}
                      </p>
                      <p className="text-sm">
                        <span className="font-medium">Created:</span><br/>
                        {formatDateTime(booking.created_at)}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </Card>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};
